import GATSBY_COMPILED_MDX from "/Users/marcaubanel/Documents/GitHub/dmae-website/src/assets/posts/news/2019/2019-02-01-Global-Game-Jam-Wrap-Up.mdx";
import * as React from "react";
import Layout from "../components/layouts/post-layout";
import {graphql} from "gatsby";
import Container from "../components/bootstrap/container";
import Row from "../components/bootstrap/row";
import Col from "../components/bootstrap/col";
import ImageVid from "../components/shared/image-or-video";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import SocialMedia from "../components/shared/social-media";
import Seo2 from "../components/shared/seo2";
import {GetISODate, GetImageURL} from "../utils/utilities";
const NewsPost = ({data, children}) => {
  const faculties = data?.faculty;
  let authorImage = {};
  return React.createElement(Layout, {
    academicsMenu: false,
    newsMenu: true,
    studentMenu: false
  }, React.createElement("div", {
    className: "bg-cream"
  }, React.createElement(Container, {
    className: "pb-6 pt-4"
  }, React.createElement("article", {
    id: "news-article"
  }, React.createElement("h1", {
    className: "visually-hidden"
  }, "News Articles"), React.createElement(Row, {
    className: "justify-content-center"
  }, React.createElement(Col, {
    xs: 12,
    sm: 8,
    lg: 7,
    xl: 6
  }, React.createElement("div", null, React.createElement(ImageVid, {
    alt: data?.mdx?.frontmatter?.title + " news story",
    imagename: data?.mdx?.frontmatter?.news_pic,
    youtube: data?.mdx?.frontmatter?.youtube_video,
    vimeo: data?.mdx?.frontmatter?.vimeo_video
  }))), React.createElement(Col, {
    xs: 12,
    sm: 3,
    xl: 2,
    className: "mt-auto pe-5 pt-3 px-sm-0 pt-sm-0 ps-sm-3"
  }, React.createElement("div", {
    className: "border-start border-bottom border-secondary ps-4 pb-3"
  }, faculties.nodes.find(function (value, index) {
    if (value.base === data?.mdx?.frontmatter?.author_photo) {
      authorImage = getImage(value);
    }
    return null;
  }), React.createElement(GatsbyImage, {
    image: authorImage,
    alt: `${data?.mdx?.frontmatter?.title} author photo`,
    className: "rounded-circle"
  }), React.createElement("ul", {
    className: "news-credits list-unstyled text-secondary mb-0 lh-1 lh-sm-2"
  }, React.createElement("li", {
    className: "mb-0"
  }, React.createElement("span", null, React.createElement("small", null, React.createElement("strong", null, data?.mdx?.frontmatter?.author)))), React.createElement("li", {
    className: "mb-0"
  }, React.createElement("small", null, data?.mdx?.frontmatter?.email)), React.createElement("li", {
    className: "mb-0"
  }, React.createElement("small", null, data?.mdx?.frontmatter?.job_position)))))), React.createElement(Row, {
    className: "justify-content-center pt-2"
  }, React.createElement(Col, {
    xs: 12,
    sm: 11,
    lg: 10,
    xl: 8
  }, React.createElement("header", {
    className: "post-header clearfix d-flex"
  }, React.createElement("h2", {
    className: "h2 mt-3 mb-0 text-lsu-purple d-inline-block"
  }, data?.mdx?.frontmatter?.title), React.createElement("p", {
    className: "date mb-0 text-lsu-purple d-inline-block float-right align-items-center mt-4 ms-2 ms-sm-5"
  }, data?.mdx?.frontmatter?.date), React.createElement("p", {
    className: "visually-hidden"
  }, React.createElement("span", null, React.createElement("span", null, "Louisiana State University")))), React.createElement("hr", {
    className: "mt-1 mb-3 border border-lsu-gold"
  }), React.createElement("div", {
    className: `two-column text-dark mb-3`
  }, React.createElement("div"), children), React.createElement(SocialMedia, {
    site: data?.mdx?.fields?.slug + "/",
    title: data?.mdx?.frontmatter?.title
  })))))));
};
NewsPost
export default function GatsbyMDXWrapper(props) {
  return React.createElement(NewsPost, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export function Head({location, data}) {
  const CurrentDateTime = GetISODate(data?.mdx?.frontmatter?.date);
  let video = "";
  if (data?.mdx.frontmatter?.youtube_video !== null) {
    video = `https://www.youtube.com/embed/${data?.mdx?.frontmatter?.youtube_video}`;
  } else if (video === "") {
    if (data?.mdx.frontmatter?.vimeo_video !== null) {
      video = `https://player.vimeo.com/video/${data?.mdx?.frontmatter?.vimeo_video}`;
    }
  }
  const fullSiteUrl = location.pathname;
  const image = GetImageURL(data?.seoImage?.frontmatter?.news_pic, data?.mdx?.childUtube, data?.mdx?.childrenOembedVim);
  const keywords = ["news blog post", "louisiana state university", "lsu", "digital media arts & engineering", "digital media center", "video game programmer", "gaming schools", "gaming university", "digital arts", "video game university", "digital media"];
  return React.createElement(React.Fragment, null, React.createElement(Seo2, {
    title: data?.mdx?.frontmatter?.title,
    type: "NewsArticle",
    ogType: "article",
    image: image,
    keywrds: [keywords],
    url: fullSiteUrl,
    description: data?.mdx?.excerpt,
    author: data?.mdx?.frontmatter?.author,
    date: CurrentDateTime,
    video: video
  }));
}
export const pageQuery = graphql`
  query NewsQuery($id: String) {
    mdx(id: { eq: $id }, frontmatter: { published: { ne: "draft" } }) {
      childrenOembedVim {
        thumbnail_url
        thumbnail_height
        thumbnail_width
      }
      childUtube {
        thumbnails {
          high {
            url
            height
            width
          }
        }
      }
      fields {
        slug
      }
      excerpt(pruneLength: 200)
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        author
        email
        job_position
        youtube_video
        vimeo_video
        author_photo
        news_pic {
          childImageSharp {
            gatsbyImageData
            resize(width: 1200) {
              height
              width
              src
            }
          }
        }
      }
    }
    faculty: allFile(
      filter: {
        relativeDirectory: { eq: "faculty" }
        extension: { regex: "/(jpg)|(png)|(tif)|(tiff)|(webp)|(jpeg)/" }
      }
    ) {
      nodes {
        childImageSharp {
          gatsbyImageData(width: 50, height: 50, layout: FIXED)
        }
        base
      }
    }
    seoImage: mdx(id: { eq: $id }) {
      frontmatter {
        news_pic {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED)
            resize(width: 1200) {
              height
              width
              src
            }
          }
        }
      }
    }
  }
`;
